
import { TypedVue } from "@/store/types";
import { Component, Inject, Prop } from "vue-property-decorator";
import VueI18n from "vue-i18n";
import { CompetencyGroup } from "@/lib/competencies";
import { CandidateSummary, FLAG_TOOLTIP_KEYS } from "./shared";
import LevelDot from "./LevelDot.vue";
import DiscussionFlag from "./DiscussionFlag.vue";
import ParticipantTag from "./ParticipantTag.vue";

@Component({
  components: {
    LevelDot,
    DiscussionFlag,
    ParticipantTag,
  },
})
export default class CandidateFitCard extends TypedVue {
  @Inject("$i18n") readonly $i18n!: VueI18n;

  @Prop({ required: true })
  readonly summary!: CandidateSummary;

  @Prop({ required: true })
  readonly rank!: number;

  @Prop({ default: false })
  readonly defaultOpen!: boolean;

  @Prop({ default: false })
  readonly printing!: boolean;

  public open = this.defaultOpen;

  get isOpen(): boolean {
    return this.printing || this.open;
  }

  get mustGroup(): CompetencyGroup {
    return this.summary.groups[0];
  }

  get niceGroup(): CompetencyGroup {
    return this.summary.groups[1];
  }

  get flaggedCount(): number {
    return this.summary.watchOuts.length;
  }

  get columns() {
    const labels: Array<{ key: string; labelKey: string; level: number }> = [
      { key: "must", labelKey: "Priority::MustHaves", level: 2 },
      { key: "nice", labelKey: "Priority::NiceToHaves", level: 1 },
      { key: "neutral", labelKey: "Priority::Neutrals", level: 0 },
    ];
    return labels.map((col, i) => ({ ...col, items: this.summary.groups[i].items }));
  }

  flagTooltip(level: number): string {
    const key = FLAG_TOOLTIP_KEYS[level];
    return key ? this.$t(key).toString() : "";
  }
}
